// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__25S-G","noInteraction":"EventWrapper_noInteraction__1YoTR","pointerPassthrough":"EventWrapper_pointerPassthrough__1_Orr"};